import { render, staticRenderFns } from "./404.vue?vue&type=template&id=560c4c70&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"
import style0 from "./404.vue?vue&type=style&index=0&id=560c4c70&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560c4c70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('560c4c70')) {
      api.createRecord('560c4c70', component.options)
    } else {
      api.reload('560c4c70', component.options)
    }
    module.hot.accept("./404.vue?vue&type=template&id=560c4c70&scoped=true", function () {
      api.rerender('560c4c70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/404.vue"
export default component.exports